import { useLocation } from 'react-router-dom';

/**
 * Guest (unauthenticated) contexts: the one-off booking flow (/booking/...) and
 * the token-gated guest view of a submitted request (/guest/...).
 *
 * Centralised so every guest-gated control (hidden comments, edit buttons,
 * logout, notifications, on-behalf email, etc.) derives "is this a guest?" from
 * one place. A future route can't accidentally re-enable authenticated-only UI,
 * and the decision is driven purely by the URL — never by persisted auth state
 * (userData), which could be present from another tab.
 */
export const GUEST_PATH_SEGMENTS = ['/booking/', '/guest/'];

const useIsGuest = (): boolean => {
    const { pathname } = useLocation();
    return GUEST_PATH_SEGMENTS.some((segment) => pathname.includes(segment));
};

export default useIsGuest;
